<div class="temple-pandit-details-container">
  <form>
    <h3>Pandit / Temple</h3>
    <h4>Reset Password</h4>

    <div class="row white-box">
      <div class="col-md-12 MT-10">
        <label>New Password</label>
        <mat-form-field appearance="outline" floatLabel="never">
          <!-- <mat-label>New Password</mat-label> -->
          <input type="password" matInput placeholder="Enter new password" />
        </mat-form-field>
      </div>

      <div class="col-md-12 MT-10">
        <label>Confirm Password</label>
        <mat-form-field appearance="outline" floatLabel="never">
          <!-- <mat-label>Confirm Password</mat-label> -->
          <input
            type="password"
            matInput
            placeholder="Enter confirm password"
          />
        </mat-form-field>
      </div>

      <div class="col-md-12 MB-10 text-center">
        <button
          type="submit"
          mat-raised-button
          class="black-btn"
          color="primary"
        >
          Reset Password
        </button>
      </div>
    </div>
  </form>
</div>
